export default "__VITE_ASSET__4ROSfDyJ__"